(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
/* Native-scroll carousel. No product clones or changes to Dawn's quick-add flow. */
if (!customElements.get('imp-featured-carousel')) {
  class ImpFeaturedCarousel extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.measureFrame);
      cancelAnimationFrame(this.scrollFrame);
      clearTimeout(this.settleTimer);
      this.events?.abort();
      this.observer?.disconnect();
      this.endDrag(false);
      this.ready = false;
    }

    init() {
      if (this.ready || !this.isConnected) return;
      this.viewport = this.querySelector('[data-fc-track]');
      if (!this.viewport) return;
      this.cards = Array.from(this.viewport.children).filter(node => node.matches('.impressiko-product-card'));
      if (!this.cards.length) return;
      this.ready = true;
      this.events = new AbortController();
      this.controls = this.querySelector('[data-fc-controls]');
      this.prev = this.querySelector('[data-fc-prev]');
      this.next = this.querySelector('[data-fc-next]');
      this.dots = this.querySelector('[data-fc-dots]');
      this.counter = this.querySelector('[data-fc-counter]');
      this.progress = this.querySelector('[data-fc-progress]');
      this.status = this.querySelector('[data-fc-status]');
      this.media = matchMedia('(min-width: 750px)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.positions = [0];
      this.index = 0;
      const listen = (node, type, fn, options = {}) => {
        if (node) node.addEventListener(type, fn, { ...options, signal: this.events.signal });
      };

      listen(this.prev, 'click', () => this.step(-1));
      listen(this.next, 'click', () => this.step(1));
      listen(this.dots, 'click', event => {
        const button = event.target.closest('[data-fc-dot]');
        if (button) this.go(Number(button.dataset.fcDot));
      });
      listen(this.viewport, 'scroll', () => {
        if (!this.scrollFrame) this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = 0;
          this.update();
        });
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => {
          this.pending = null;
          this.update(true);
        }, 140);
      }, { passive: true });
      listen(this.viewport, 'keydown', event => {
        // Leave buttons, product links and quick-view keyboard controls alone.
        if (event.target !== this.viewport || !this.enabled || this.max < 2) return;
        const forward = this.rtl ? 'ArrowLeft' : 'ArrowRight';
        const backward = this.rtl ? 'ArrowRight' : 'ArrowLeft';
        if (event.key === forward) this.step(1);
        else if (event.key === backward) this.step(-1);
        else if (event.key === 'Home') this.go(0);
        else if (event.key === 'End') this.go(this.positions.length - 1);
        else return;
        event.preventDefault();
      });
      listen(this.viewport, 'focusin', event => {
        if (!this.enabled || this.drag) return;
        const card = event.target.closest('.impressiko-product-card');
        if (!card || card.parentElement !== this.viewport) return;
        const box = card.getBoundingClientRect();
        const frame = this.viewport.getBoundingClientRect();
        if (box.left < frame.left - 2 || box.right > frame.right + 2) {
          const index = this.cards.indexOf(card);
          const target = Math.min(this.max, Math.max(0, this.offsets[index]));
          this.scrollToOffset(target);
        }
      });

      // Touch/pen scrolling remains native, including vertical page movement.
      listen(this.viewport, 'pointerdown', event => {
        if (!this.enabled || this.max < 2 || this.dataset.mouseDrag !== 'true') return;
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (event.target.closest('button, input, select, textarea, summary, modal-opener, [role="button"]')) return;
        this.pending = null;
        this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, position: this.position(), moved: false };
      });
      listen(window, 'pointermove', event => {
        const drag = this.drag;
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.x;
        const dy = event.clientY - drag.y;
        if (!drag.moved) {
          if (Math.abs(dx) < 6) return;
          if (Math.abs(dy) > Math.abs(dx)) { this.drag = null; return; }
          drag.moved = true;
          this.viewport.classList.add('is-fc-dragging');
          try { this.viewport.setPointerCapture(drag.id); } catch (_) { /* Pointer may already be released. */ }
        }
        if (event.cancelable) event.preventDefault();
        this.setPosition(drag.position + (this.rtl ? dx : -dx));
      });
      listen(window, 'pointerup', event => {
        if (this.drag?.id === event.pointerId) this.endDrag(true);
      });
      listen(window, 'pointercancel', event => {
        if (this.drag?.id === event.pointerId) this.endDrag(false);
      });
      listen(this.viewport, 'dragstart', event => {
        if (this.enabled && this.dataset.mouseDrag === 'true') event.preventDefault();
      });
      listen(this.viewport, 'click', event => {
        if (performance.now() < (this.suppressClickUntil || 0)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { capture: true });

      this.lastWidth = -1;
      const scheduleMeasure = () => {
        if (!this.measureFrame) this.measureFrame = requestAnimationFrame(() => {
          this.measureFrame = 0;
          this.measure();
        });
      };
      listen(window, 'resize', scheduleMeasure, { passive: true });
      listen(this.media, 'change', scheduleMeasure);
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => {
          const width = this.viewport.clientWidth;
          if (Math.abs(width - this.lastWidth) > 0.5) scheduleMeasure();
        });
        this.observer.observe(this.viewport);
      }
      this.measure();
    }

    position() {
      const raw = this.rtl ? -this.viewport.scrollLeft : this.viewport.scrollLeft;
      return Math.min(this.max || 0, Math.max(0, raw));
    }

    setPosition(value) {
      const position = Math.max(0, Math.min(this.max, value));
      this.viewport.scrollLeft = this.rtl ? -position : position;
    }

    scrollToOffset(value, smooth = true) {
      const position = Math.max(0, Math.min(this.max, value));
      this.viewport.scrollTo({
        left: this.rtl ? -position : position,
        behavior: smooth && !this.motion.matches ? 'smooth' : 'auto'
      });
    }

    measure() {
      if (!this.isConnected || !this.ready) return;
      this.endDrag(false);
      const oldAnchor = this.anchor || 0;
      const oldEnabled = this.enabled;
      const desktop = this.media.matches;
      this.enabled = (desktop ? this.dataset.desktopSlider : this.dataset.mobileSlider) === 'true';
      this.rtl = getComputedStyle(this.viewport).direction === 'rtl';
      this.lastWidth = this.viewport.clientWidth;
      this.max = Math.max(0, this.viewport.scrollWidth - this.lastWidth);
      const frame = this.viewport.getBoundingClientRect();
      const current = this.position();
      this.offsets = this.cards.map(card => {
        const box = card.getBoundingClientRect();
        return current + (this.rtl ? frame.right - box.right : box.left - frame.left);
      });
      this.positions = [0];
      if (this.enabled && this.max > 2) {
        this.offsets.slice(1).forEach(offset => {
          const value = Math.max(0, Math.min(this.max, offset));
          if (value - this.positions[this.positions.length - 1] > 2) this.positions.push(value);
        });
        if (this.max - this.positions[this.positions.length - 1] > 2) this.positions.push(this.max);
      }
      const overflow = this.enabled && this.max > 2;
      this.dataset.fcOverflow = String(overflow);
      this.viewport.tabIndex = overflow ? 0 : -1;
      this.viewport.setAttribute('aria-label', overflow ? this.dataset.sliderLabel : this.dataset.listLabel);
      const showArrows = overflow && (desktop ? this.dataset.arrowsDesktop : this.dataset.arrowsMobile) === 'true';
      const pagination = desktop ? this.dataset.paginationDesktop : this.dataset.paginationMobile;
      if (this.prev) this.prev.hidden = !showArrows;
      if (this.next) this.next.hidden = !showArrows;
      if (this.counter) this.counter.hidden = !overflow || pagination !== 'counter';
      if (this.progress) this.progress.hidden = !overflow || pagination !== 'progress';
      if (this.dots) this.dots.hidden = !overflow || pagination !== 'dots';
      if (this.controls) this.controls.hidden = !overflow || (!showArrows && pagination === 'none');
      this.pagination = pagination;
      if (this.dots && this.dots.children.length !== this.positions.length) {
        const fragment = document.createDocumentFragment();
        this.positions.forEach((_, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'impressiko-featured__dot';
          button.dataset.fcDot = String(index);
          button.setAttribute('aria-controls', this.viewport.id);
          button.setAttribute('aria-label', `${this.dataset.positionLabel} ${index + 1}`);
          fragment.appendChild(button);
        });
        this.dots.replaceChildren(fragment);
      }
      this.pending = null;
      if (!this.enabled || !oldEnabled) this.setPosition(0);
      else this.setPosition(this.offsets[Math.min(oldAnchor, this.cards.length - 1)] || 0);
      this.update();
    }

    nearest(value) {
      let best = 0;
      let distance = Infinity;
      this.positions.forEach((position, index) => {
        if (Math.abs(position - value) < distance) {
          distance = Math.abs(position - value);
          best = index;
        }
      });
      return best;
    }

    go(index, smooth = true) {
      if (!this.enabled || this.max < 2) return;
      const clamped = Math.max(0, Math.min(this.positions.length - 1, index));
      this.pending = clamped;
      this.scrollToOffset(this.positions[clamped], smooth);
      if (!smooth || this.motion.matches) this.update(true);
    }

    step(direction) {
      const desktop = this.media.matches;
      const columns = Number(desktop ? this.dataset.columnsDesktop : this.dataset.columnsMobile) || 1;
      const jump = this.dataset.scrollStep === 'page' ? Math.max(1, Math.floor(columns)) : 1;
      this.go((this.pending ?? this.nearest(this.position())) + jump * direction);
    }

    endDrag(snap) {
      const drag = this.drag;
      if (!drag) return;
      this.drag = null;
      if (drag.moved) {
        const position = this.position();
        this.suppressClickUntil = performance.now() + 350;
        this.viewport.classList.remove('is-fc-dragging');
        try { this.viewport.releasePointerCapture(drag.id); } catch (_) { /* Already released. */ }
        if (snap && this.dataset.snap === 'true') this.go(this.nearest(position));
      }
    }

    update(announce = false) {
      if (!this.ready) return;
      const value = this.position();
      this.index = this.nearest(value);
      if (this.prev) this.prev.disabled = value <= 2;
      if (this.next) this.next.disabled = value >= this.max - 2;
      if (this.dots) Array.from(this.dots.children).forEach((button, index) => {
        if (index === this.index) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      if (this.progress) {
        const fraction = (this.index + 1) / this.positions.length;
        this.progress.style.setProperty('--fc-progress', String(fraction));
      }
      const visible = [];
      this.offsets.forEach((offset, index) => {
        const width = this.cards[index].getBoundingClientRect().width;
        if (offset + width > value + 2 && offset < value + this.lastWidth - 2) visible.push(index);
      });
      this.anchor = visible[0] || 0;
      const first = this.anchor + 1;
      const last = (visible[visible.length - 1] ?? this.anchor) + 1;
      const range = first === last ? String(first) : `${first}\u2013${last}`;
      if (this.counter) this.counter.textContent = `${range} / ${this.cards.length}`;
      if (announce && this.status) this.status.textContent = `${this.dataset.listLabel}: ${range} / ${this.cards.length}`;
    }
  }
  customElements.define('imp-featured-carousel', ImpFeaturedCarousel);
}


/*
 * Impressiko Featured Collection: direct Add to Cart + optional Buy Now.
 * IMPORTANT: this store uses the separately installed Side Cart Drawer, not Dawn's
 * cart-drawer section. The dynamic section ID is read from its data-section-id.
 * Never redirect an Add to Cart click to /cart.
 */
if (!customElements.get('imp-featured-actions')) {
  class ImpFeaturedActions extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      this.dialog = this.querySelector('[data-fc-dialog]');
      this.variantSelect = this.querySelector('[data-fc-variant-select]');
      this.errorNode = this.querySelector('[data-fc-error]');
      this.addButton = this.querySelector('[data-fc-action="add"]');
      this.buyButton = this.querySelector('[data-fc-action="buy"]');
      this.confirmButton = this.querySelector('[data-fc-dialog-confirm]');

      this.addEventListener('click', event => {
        const close = event.target.closest('[data-fc-dialog-close]');
        if (close) { this.dialog?.close(); return; }
        const confirm = event.target.closest('[data-fc-dialog-confirm]');
        if (confirm) {
          this.run(this.pendingAction || 'add', this.variantSelect?.value, confirm);
          return;
        }
        const actionButton = event.target.closest('[data-fc-action]');
        if (!actionButton || this.busy) return;
        const action = actionButton.dataset.fcAction;
        if (this.dataset.requiresPlan === 'true') {
          // Selling-plan products require an explicit plan choice on the PDP.
          window.location.assign(this.dataset.productUrl);
          return;
        }
        if (this.dataset.hasOptions === 'true') {
          this.pendingAction = action;
          this.error('');
          if (this.confirmButton) {
            this.confirmButton.classList.toggle('impressiko-product-card__button--buy', action === 'buy');
            const label = this.confirmButton.querySelector('[data-fc-label]');
            if (label) label.textContent = action === 'buy' ? this.dataset.buyText : this.dataset.addText;
          }
          if (typeof this.dialog?.showModal === 'function') {
            this.dialog.showModal();
            this.variantSelect?.focus();
          } else {
            window.location.assign(this.dataset.productUrl);
          }
          return;
        }
        this.run(action, this.dataset.variantId, actionButton);
      }, { signal: this.abortController.signal });

      this.dialog?.addEventListener('close', () => {
        this.pendingAction = null;
      }, { signal: this.abortController.signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }

    error(message) {
      if (!this.errorNode) return;
      this.errorNode.textContent = message;
      this.errorNode.hidden = !message;
    }

    setBusy(active, button) {
      this.busy = active;
      this.querySelectorAll('[data-fc-action], [data-fc-dialog-confirm]').forEach(node => {
        node.disabled = active;
      });
      if (!button) return;
      const label = button.querySelector('[data-fc-label]');
      if (active) {
        button.dataset.fcLoading = 'true';
        if (label) {
          button.dataset.fcOriginalLabel = label.textContent;
          label.textContent = this.dataset.addingText || 'Adding...';
        }
      } else {
        delete button.dataset.fcLoading;
        if (label && button.dataset.fcOriginalLabel !== undefined) {
          label.textContent = button.dataset.fcOriginalLabel;
          delete button.dataset.fcOriginalLabel;
        }
      }
    }

    findSideCart() {
      return document.querySelector('cart-drawer[data-side-cart-root][data-section-id]')
        || document.querySelector('cart-drawer[data-side-cart-root]');
    }

    parseSideCart(sectionHTML, expectedId) {
      if (typeof sectionHTML !== 'string' || !sectionHTML.trim()) return null;
      const parsed = new DOMParser().parseFromString(sectionHTML, 'text/html');
      const drawer = parsed.querySelector('cart-drawer[data-side-cart-root]');
      if (!drawer) return null;
      if (expectedId && drawer.dataset.sectionId && drawer.dataset.sectionId !== expectedId) return null;
      return drawer;
    }

    async fetchSideCartSection(sectionId) {
      // If bundled rendering returns null, try the Section Rendering API independently.
      // The ID must be the live dynamic group ID, never a hardcoded 'cart-drawer'.
      const root = window.Shopify?.routes?.root || '/';
      const paths = [window.location.pathname, root];
      for (const path of [...new Set(paths)]) {
        const url = new URL(path, window.location.origin);
        url.searchParams.set('section_id', sectionId);
        try {
          const response = await fetch(url.toString(), {
            method: 'GET',
            credentials: 'same-origin',
            headers: { 'Accept': 'text/html' },
            cache: 'no-store'
          });
          if (!response.ok) continue;
          const html = await response.text();
          if (this.parseSideCart(html, sectionId)) return html;
        } catch (error) {
          // A second path may work if this page template cannot render that section.
          console.warn('[Featured Collection] Side cart section request failed:', error);
        }
      }
      return null;
    }

    updateCartBubble(html) {
      if (typeof html !== 'string' || !html) return;
      const existing = document.querySelector('#cart-icon-bubble');
      if (!existing) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const incoming = parsed.querySelector('#cart-icon-bubble');
      if (!incoming) return;

      // Keep the header cart link and its existing click listeners intact.
      // Replace only the count badge inside it.
      const currentBadge = existing.querySelector('.cart-count-bubble');
      const newBadge = incoming.querySelector('.cart-count-bubble');
      if (currentBadge && newBadge) {
        currentBadge.replaceWith(newBadge);
      } else if (currentBadge) {
        currentBadge.remove();
      } else if (newBadge) {
        existing.appendChild(newBadge);
      }
    }

    async updateSideCart(data, sectionId) {
      const current = this.findSideCart();
      if (!current || !sectionId) return null;
      if (current.renderSections?.(data?.sections, data?.item_count)) return current;

      let html = data?.sections?.[sectionId];
      let replacement = this.parseSideCart(html, sectionId);
      if (!replacement) {
        html = await this.fetchSideCartSection(sectionId);
        replacement = this.parseSideCart(html, sectionId);
      }
      if (!replacement) return null;
      if (current.renderSections?.({ [sectionId]: html }, data?.item_count)) return current;

      // Recreate the *custom* cart-drawer Web Component using the freshly rendered
      // Liquid, including its products, totals, rewards, offers, and recommendations.
      // This triggers connectedCallback in side-cart-drawer.js and avoids calling
      // Dawn's incompatible renderContents() or relying on 'cart-drawer' as an ID.
      current.replaceWith(document.importNode(replacement, true));
      return this.findSideCart();
    }

    static closeFallbackDrawer(drawer) {
      if (!drawer?.hasAttribute('data-fc-fallback-open')) return;
      drawer.removeAttribute('data-fc-fallback-open');
      drawer.classList.remove('active', 'is-open', 'open');
      drawer.setAttribute('aria-hidden', 'true');
      if (drawer.__fcPreviousOverflow !== undefined) {
        document.documentElement.style.overflow = drawer.__fcPreviousOverflow;
        delete drawer.__fcPreviousOverflow;
      }
      const origin = drawer.__fcOpener;
      if (origin?.isConnected) origin.focus({ preventScroll: true });
      delete drawer.__fcOpener;
    }

    static installFallbackClose() {
      if (ImpFeaturedActions.fallbackInstalled) return;
      ImpFeaturedActions.fallbackInstalled = true;
      document.addEventListener('click', event => {
        const close = event.target.closest?.('[data-side-cart-close]');
        if (!close) return;
        const drawer = close.closest('cart-drawer[data-side-cart-root][data-fc-fallback-open]');
        if (drawer) ImpFeaturedActions.closeFallbackDrawer(drawer);
      }, true);
      document.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const drawer = document.querySelector('cart-drawer[data-side-cart-root][data-fc-fallback-open]');
        if (drawer) ImpFeaturedActions.closeFallbackDrawer(drawer);
      }, true);
    }

    openSideCart(drawer, opener) {
      if (!drawer) return false;
      // Use the drawer's own controller whenever available. This preserves
      // its animations, overlay, focus trap and open/close logic.
      const nativeMethod = ['open', 'openDrawer', 'showDrawer'].find(name => typeof drawer[name] === 'function');
      if (nativeMethod) {
        try {
          drawer[nativeMethod](opener);
          return true;
        } catch (error) {
          console.warn('[Featured Collection] Native side cart open failed; using fallback.', error);
        }
      }

      // The provided Liquid includes the root/panel/overlay but not the JS asset.
      // This independent fallback still opens it if there is no public JS opener.
      ImpFeaturedActions.installFallbackClose();
      drawer.__fcOpener = opener;
      drawer.__fcPreviousOverflow = document.documentElement.style.overflow;
      drawer.setAttribute('data-fc-fallback-open', '');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.removeAttribute('inert');
      drawer.classList.add('active', 'is-open');
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        if (drawer.isConnected && drawer.hasAttribute('data-fc-fallback-open')) {
          drawer.querySelector('.side-cart__panel')?.focus({ preventScroll: true });
        }
      });
      return true;
    }

    /**
     * Reuse the existing side cart's burst if its controller exposes a public
     * no-argument method; otherwise display an equivalent configured particle
     * burst. We cannot rely on the drawer's internal add-to-cart event here,
     * because the featured section uses its own Shopify AJAX request.
     */
    triggerAddedBurst(drawer) {
      if (!drawer || drawer.dataset.burstEnabled !== 'true') return;
      if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;

      // Give the side panel a moment to enter after its own open() transition.
      window.setTimeout(() => {
        if (!drawer.isConnected || drawer.dataset.burstEnabled !== 'true') return;
        try {
          const methodNames = [
            'triggerPopBurst', 'playPopBurst', 'triggerBurst', 'playBurst',
            'showBurst', 'launchBurst', 'fireBurst', 'startBurst'
          ];
          const nativeMethod = methodNames.find(name => {
            const fn = drawer[name];
            return typeof fn === 'function' && fn.length === 0;
          });
          if (nativeMethod) {
            drawer[nativeMethod]();
            return;
          }
          this.showConfiguredBurst(drawer);
        } catch (error) {
          console.warn('[Featured Collection] Native drawer burst failed; using configured burst.', error);
          try { this.showConfiguredBurst(drawer); } catch (_) { /* Non-critical visual effect */ }
        }
      }, 160);
    }

    showConfiguredBurst(drawer) {
      if (!drawer || drawer.dataset.burstEnabled !== 'true') return;
      const panel = drawer.querySelector('.side-cart__panel') || drawer.querySelector('#CartDrawer');
      if (!panel) return;

      const count = Math.min(80, Math.max(0, Math.round(Number(drawer.dataset.burstCount) || 48)));
      if (count === 0) return;
      const colors = (drawer.dataset.burstColors || '')
        .split(',')
        .map(c => c.trim())
        .filter(c => /^#[a-fA-F0-9]{3}(?:[a-fA-F0-9]{3})?(?:[a-fA-F0-9]{2})?$/.test(c));
      if (!colors.length) colors.push('#3e579e', '#12ad93', '#f6c555', '#e77871');

      // Clean any unfinished prior animation before starting another.
      document.querySelectorAll('.impressiko-sidecart-burst-layer').forEach(node => node.remove());

      const rect = panel.getBoundingClientRect();
      // Origin near the top of the visible cart panel (not the product card).
      const x = Math.round(Math.max(24, Math.min(innerWidth - 24, rect.left + rect.width * .50)));
      const y = Math.round(Math.max(42, Math.min(innerHeight - 42, rect.top + Math.min(155, rect.height * .25))));
      const layer = document.createElement('div');
      layer.className = 'impressiko-sidecart-burst-layer';
      layer.setAttribute('aria-hidden', 'true');
      layer.dataset.from = 'featured-collection';
      const fragment = document.createDocumentFragment();

      for (let i = 0; i < count; i++) {
        const particle = document.createElement('i');
        particle.className = 'impressiko-sidecart-burst-particle';
        particle.setAttribute('aria-hidden', 'true');
        const angle = ((Math.PI * 2) * i / count) + (Math.random() - .5) * .55;
        const distance = 95 + Math.random() * Math.min(125, rect.width * .45);
        const dx = Math.round(Math.cos(angle) * distance);
        const dy = Math.round(Math.sin(angle) * distance + 55 + Math.random() * 55);
        const size = 5 + Math.random() * 6;
        const css = particle.style;
        css.setProperty('--fc-burst-x', `${x}px`);
        css.setProperty('--fc-burst-y', `${y}px`);
        css.setProperty('--fc-burst-dx', `${dx}px`);
        css.setProperty('--fc-burst-dy', `${dy}px`);
        css.setProperty('--fc-burst-w', `${size.toFixed(1)}px`);
        css.setProperty('--fc-burst-h', `${(size * (i % 4 ? 1.6 : 1)).toFixed(1)}px`);
        css.setProperty('--fc-burst-round', i % 5 === 0 ? '50%' : '1px');
        css.setProperty('--fc-burst-color', colors[i % colors.length]);
        css.setProperty('--fc-burst-time', `${780 + Math.round(Math.random() * 480)}ms`);
        css.setProperty('--fc-burst-delay', `${Math.round(Math.random() * 95)}ms`);
        css.setProperty('--fc-burst-rotation', `${-540 + Math.round(Math.random() * 1080)}deg`);
        fragment.appendChild(particle);
      }
      layer.appendChild(fragment);
      document.body.appendChild(layer);
      window.setTimeout(() => layer.remove(), 1500);
    }

    async run(action, variantId, trigger) {
      if (this.busy) return;
      const id = Number(variantId);
      if (!Number.isSafeInteger(id) || id <= 0) {
        this.error('Please select a valid product option.');
        return;
      }
      if (action === 'buy') {
        // Separate checkout flow: bypass the cart page and the drawer.
        const cartUrl = (this.dataset.cartUrl || '/cart').replace(/\/$/, '');
        window.location.assign(`${cartUrl}/${id}:1`);
        return;
      }

      this.dialog?.open && this.dialog.close();
      this.error('');
      const drawer = this.findSideCart();
      if (!drawer) {
        this.error('Side Cart Drawer is not loaded. Please enable it in your theme settings.');
        return;
      }

      if (drawer.beginAdd?.(this.addButton || trigger) === false) return;
      this.setBusy(true, trigger);
      const sectionId = drawer.dataset.sectionId || drawer.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '');
      const sections = [sectionId].filter(Boolean);
      const cartUrl = this.dataset.cartUrl || '/cart';
      let added = false;
      try {
        const addUrl = `${(this.dataset.addUrl || `${cartUrl}/add`).replace(/\/$/, '')}.js`;
        const response = await fetch(addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{ id, quantity: 1 }],
            sections,
            sections_url: window.location.pathname
          })
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Unable to add this item. Please try again.');
        }
        added = true;


        const refreshedDrawer = await this.updateSideCart(data, sectionId);
        const drawerToOpen = refreshedDrawer || this.findSideCart();
        if (refreshedDrawer) refreshedDrawer.showStatus?.(refreshedDrawer.dataset.addedMessage || 'Added to your cart', 'success');
        if (this.openSideCart(drawerToOpen, this.addButton || trigger)) {
          this.triggerAddedBurst(drawerToOpen);
        }
        if (!refreshedDrawer) {
          this.error('Added to cart, but the drawer could not refresh. Please try reopening the drawer.');
        }
      } catch (error) {
        this.error(added
          ? 'Added to cart, but its drawer could not be refreshed. Please try reopening it.'
          : (error?.message || 'Could not add this item. Please try again.'));
        if (added) {
          const remainingDrawer = this.findSideCart();
          if (this.openSideCart(remainingDrawer, this.addButton || trigger)) {
            this.triggerAddedBurst(remainingDrawer);
          }
        }
        this.findSideCart()?.showStatus?.(error?.message || 'Could not add this item.', 'error');
        console.error('[Featured Collection] Add to cart:', error);
      } finally {
        drawer.endAdd?.();
        this.setBusy(false, trigger);
      }
    }
  }

  customElements.define('imp-featured-actions', ImpFeaturedActions);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search, [data-impressiko-live-search]');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
      this.customSearches = this.customSearches || this.header.querySelectorAll('[data-impressiko-live-search]');
      this.customSearches.forEach((search) => search._impressikoSearchClose?.());
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  if (!customElements.get('noki-recipe-cart')) {
    customElements.define('noki-recipe-cart', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.addEventListener('submit', event => this.addProducts(event), { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
      async addProducts(event) {
        const form = event.target;
        if (!form.matches('[data-recipe-product-form], [data-recipe-add-all]')) return;
        event.preventDefault();
        if (this.busy) return;
        const forms = form.hasAttribute('data-recipe-add-all') ? [...this.querySelectorAll('[data-recipe-product-form]')] : [form];
        const items = forms.map(itemForm => ({ id: Number(itemForm.elements.id.value), quantity: Number(itemForm.elements.quantity.value) || 1 }));
        if (!items.length || items.some(item => !item.id)) return;
        const button = event.submitter || form.querySelector('button');
        const label = button.querySelector('[data-recipe-button-label]');
        const previousLabel = label.textContent;
        const errorNode = this.querySelector('[role="alert"]');
        const buttons = [...this.querySelectorAll('button')].map(element => ({ element, disabled: element.disabled }));
        this.busy = true;
        this.setAttribute('aria-busy', 'true');
        buttons.forEach(({ element }) => { element.disabled = true; });
        label.textContent = this.dataset.adding;
        errorNode.hidden = true;
        let added = false;
        try {
          const drawer = document.querySelector('cart-drawer[data-side-cart-root]') || document.querySelector('cart-drawer');
          const payload = { items };
          if (drawer?.getSectionsToRender) {
            payload.sections = drawer.getSectionsToRender().map(section => section.id);
            payload.sections_url = window.location.pathname + window.location.search;
            drawer.setActiveElement?.(button);
          }
          const response = await fetch(this.dataset.addUrl.replace(/\.js$/, '') + '.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(payload)
          });
          const state = await response.json();
          if (!response.ok || Number(state.status) >= 400) throw new Error(state.description || state.message || this.dataset.error);
          added = true;
          if (drawer?.consumeState) {
            await drawer.consumeState(state, { open: true, burst: true, reason: 'add' });
            drawer.publishCartUpdate?.(state);
          } else if (drawer?.renderContents) {
            drawer.renderContents(state);
          } else {
            window.location.assign(this.dataset.cartUrl);
          }
        } catch (error) {
          errorNode.textContent = added ? this.dataset.refreshError : (error.message || this.dataset.error);
          errorNode.hidden = false;
        } finally {
          buttons.forEach(({ element, disabled }) => { element.disabled = disabled; });
          label.textContent = previousLabel;
          this.removeAttribute('aria-busy');
          this.busy = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    

/* Native-scroll carousel. Filter, sort and pagination remain native to Dawn. */
if (!customElements.get('imp-collection-carousel')) {
  class ImpCollectionCarousel extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.measureFrame);
      cancelAnimationFrame(this.scrollFrame);
      clearTimeout(this.settleTimer);
      this.events?.abort();
      this.observer?.disconnect();
      this.endDrag(false);
      this.ready = false;
    }

    init() {
      if (this.ready || !this.isConnected) return;
      this.viewport = this.querySelector('[data-fc-track]');
      if (!this.viewport) return;
      this.cards = Array.from(this.viewport.children).filter(node => node.matches('.impressiko-product-card'));
      if (!this.cards.length) return;
      this.ready = true;
      this.events = new AbortController();
      this.controls = this.querySelector('[data-fc-controls]');
      this.prev = this.querySelector('[data-fc-prev]');
      this.next = this.querySelector('[data-fc-next]');
      this.dots = this.querySelector('[data-fc-dots]');
      this.counter = this.querySelector('[data-fc-counter]');
      this.progress = this.querySelector('[data-fc-progress]');
      this.status = this.querySelector('[data-fc-status]');
      this.media = matchMedia('(min-width: 750px)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.positions = [0];
      this.index = 0;
      const listen = (node, type, fn, options = {}) => {
        if (node) node.addEventListener(type, fn, { ...options, signal: this.events.signal });
      };

      listen(this.prev, 'click', () => this.step(-1));
      listen(this.next, 'click', () => this.step(1));
      listen(this.dots, 'click', event => {
        const button = event.target.closest('[data-fc-dot]');
        if (button) this.go(Number(button.dataset.fcDot));
      });
      listen(this.viewport, 'scroll', () => {
        if (!this.scrollFrame) this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = 0;
          this.update();
        });
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => {
          this.pending = null;
          this.update(true);
        }, 140);
      }, { passive: true });
      listen(this.viewport, 'keydown', event => {
        // Leave buttons, product links and quick-view keyboard controls alone.
        if (event.target !== this.viewport || !this.enabled || this.max < 2) return;
        const forward = this.rtl ? 'ArrowLeft' : 'ArrowRight';
        const backward = this.rtl ? 'ArrowRight' : 'ArrowLeft';
        if (event.key === forward) this.step(1);
        else if (event.key === backward) this.step(-1);
        else if (event.key === 'Home') this.go(0);
        else if (event.key === 'End') this.go(this.positions.length - 1);
        else return;
        event.preventDefault();
      });
      listen(this.viewport, 'focusin', event => {
        if (!this.enabled || this.drag) return;
        const card = event.target.closest('.impressiko-product-card');
        if (!card || card.parentElement !== this.viewport) return;
        const box = card.getBoundingClientRect();
        const frame = this.viewport.getBoundingClientRect();
        if (box.left < frame.left - 2 || box.right > frame.right + 2) {
          const index = this.cards.indexOf(card);
          const target = Math.min(this.max, Math.max(0, this.offsets[index]));
          this.scrollToOffset(target);
        }
      });

      // Touch/pen scrolling remains native, including vertical page movement.
      listen(this.viewport, 'pointerdown', event => {
        if (!this.enabled || this.max < 2 || this.dataset.mouseDrag !== 'true') return;
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (event.target.closest('button, input, select, textarea, summary, modal-opener, .impressiko-product-card__button, [role="button"]')) return;
        this.pending = null;
        this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, position: this.position(), moved: false };
      });
      listen(window, 'pointermove', event => {
        const drag = this.drag;
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.x;
        const dy = event.clientY - drag.y;
        if (!drag.moved) {
          if (Math.abs(dx) < 6) return;
          if (Math.abs(dy) > Math.abs(dx)) { this.drag = null; return; }
          drag.moved = true;
          this.viewport.classList.add('is-fc-dragging');
          try { this.viewport.setPointerCapture(drag.id); } catch (_) { /* Pointer may already be released. */ }
        }
        if (event.cancelable) event.preventDefault();
        this.setPosition(drag.position + (this.rtl ? dx : -dx));
      });
      listen(window, 'pointerup', event => {
        if (this.drag?.id === event.pointerId) this.endDrag(true);
      });
      listen(window, 'pointercancel', event => {
        if (this.drag?.id === event.pointerId) this.endDrag(false);
      });
      listen(this.viewport, 'dragstart', event => {
        if (this.enabled && this.dataset.mouseDrag === 'true') event.preventDefault();
      });
      listen(this.viewport, 'click', event => {
        if (performance.now() < (this.suppressClickUntil || 0)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { capture: true });

      this.lastWidth = -1;
      const scheduleMeasure = () => {
        if (!this.measureFrame) this.measureFrame = requestAnimationFrame(() => {
          this.measureFrame = 0;
          this.measure();
        });
      };
      listen(window, 'resize', scheduleMeasure, { passive: true });
      listen(this.media, 'change', scheduleMeasure);
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => {
          const width = this.viewport.clientWidth;
          if (Math.abs(width - this.lastWidth) > 0.5) scheduleMeasure();
        });
        this.observer.observe(this.viewport);
      }
      this.measure();
    }

    position() {
      const raw = this.rtl ? -this.viewport.scrollLeft : this.viewport.scrollLeft;
      return Math.min(this.max || 0, Math.max(0, raw));
    }

    setPosition(value) {
      const position = Math.max(0, Math.min(this.max, value));
      this.viewport.scrollLeft = this.rtl ? -position : position;
    }

    scrollToOffset(value, smooth = true) {
      const position = Math.max(0, Math.min(this.max, value));
      this.viewport.scrollTo({
        left: this.rtl ? -position : position,
        behavior: smooth && !this.motion.matches ? 'smooth' : 'auto'
      });
    }

    measure() {
      if (!this.isConnected || !this.ready) return;
      this.endDrag(false);
      const oldAnchor = this.anchor || 0;
      const oldEnabled = this.enabled;
      const desktop = this.media.matches;
      this.enabled = (desktop ? this.dataset.desktopSlider : this.dataset.mobileSlider) === 'true';
      this.rtl = getComputedStyle(this.viewport).direction === 'rtl';
      this.lastWidth = this.viewport.clientWidth;
      this.max = Math.max(0, this.viewport.scrollWidth - this.lastWidth);
      const frame = this.viewport.getBoundingClientRect();
      const current = this.position();
      this.offsets = this.cards.map(card => {
        const box = card.getBoundingClientRect();
        return current + (this.rtl ? frame.right - box.right : box.left - frame.left);
      });
      this.positions = [0];
      if (this.enabled && this.max > 2) {
        this.offsets.slice(1).forEach(offset => {
          const value = Math.max(0, Math.min(this.max, offset));
          if (value - this.positions[this.positions.length - 1] > 2) this.positions.push(value);
        });
        if (this.max - this.positions[this.positions.length - 1] > 2) this.positions.push(this.max);
      }
      const overflow = this.enabled && this.max > 2;
      this.dataset.fcOverflow = String(overflow);
      this.viewport.tabIndex = overflow ? 0 : -1;
      this.viewport.setAttribute('aria-label', overflow ? this.dataset.sliderLabel : this.dataset.listLabel);
      const showArrows = overflow && (desktop ? this.dataset.arrowsDesktop : this.dataset.arrowsMobile) === 'true';
      const pagination = desktop ? this.dataset.paginationDesktop : this.dataset.paginationMobile;
      if (this.prev) this.prev.hidden = !showArrows;
      if (this.next) this.next.hidden = !showArrows;
      if (this.counter) this.counter.hidden = !overflow || pagination !== 'counter';
      if (this.progress) this.progress.hidden = !overflow || pagination !== 'progress';
      if (this.dots) this.dots.hidden = !overflow || pagination !== 'dots';
      if (this.controls) this.controls.hidden = !overflow || (!showArrows && pagination === 'none');
      this.pagination = pagination;
      if (this.dots && this.dots.children.length !== this.positions.length) {
        const fragment = document.createDocumentFragment();
        this.positions.forEach((_, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'impressiko-featured__dot';
          button.dataset.fcDot = String(index);
          button.setAttribute('aria-controls', this.viewport.id);
          button.setAttribute('aria-label', `${this.dataset.positionLabel} ${index + 1}`);
          fragment.appendChild(button);
        });
        this.dots.replaceChildren(fragment);
      }
      this.pending = null;
      if (!this.enabled || !oldEnabled) this.setPosition(0);
      else this.setPosition(this.offsets[Math.min(oldAnchor, this.cards.length - 1)] || 0);
      this.update();
    }

    nearest(value) {
      let best = 0;
      let distance = Infinity;
      this.positions.forEach((position, index) => {
        if (Math.abs(position - value) < distance) {
          distance = Math.abs(position - value);
          best = index;
        }
      });
      return best;
    }

    go(index, smooth = true) {
      if (!this.enabled || this.max < 2) return;
      const clamped = Math.max(0, Math.min(this.positions.length - 1, index));
      this.pending = clamped;
      this.scrollToOffset(this.positions[clamped], smooth);
      if (!smooth || this.motion.matches) this.update(true);
    }

    step(direction) {
      const desktop = this.media.matches;
      const columns = Number(desktop ? this.dataset.columnsDesktop : this.dataset.columnsMobile) || 1;
      const jump = this.dataset.scrollStep === 'page' ? Math.max(1, Math.floor(columns)) : 1;
      this.go((this.pending ?? this.nearest(this.position())) + jump * direction);
    }

    endDrag(snap) {
      const drag = this.drag;
      if (!drag) return;
      this.drag = null;
      if (drag.moved) {
        const position = this.position();
        this.suppressClickUntil = performance.now() + 350;
        this.viewport.classList.remove('is-fc-dragging');
        try { this.viewport.releasePointerCapture(drag.id); } catch (_) { /* Already released. */ }
        if (snap && this.dataset.snap === 'true') this.go(this.nearest(position));
      }
    }

    update(announce = false) {
      if (!this.ready) return;
      const value = this.position();
      this.index = this.nearest(value);
      if (this.prev) this.prev.disabled = value <= 2;
      if (this.next) this.next.disabled = value >= this.max - 2;
      if (this.dots) Array.from(this.dots.children).forEach((button, index) => {
        if (index === this.index) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      if (this.progress) {
        const fraction = (this.index + 1) / this.positions.length;
        this.progress.style.setProperty('--fc-progress', String(fraction));
      }
      const visible = [];
      this.offsets.forEach((offset, index) => {
        const width = this.cards[index].getBoundingClientRect().width;
        if (offset + width > value + 2 && offset < value + this.lastWidth - 2) visible.push(index);
      });
      this.anchor = visible[0] || 0;
      const first = this.anchor + 1;
      const last = (visible[visible.length - 1] ?? this.anchor) + 1;
      const range = first === last ? String(first) : `${first}\u2013${last}`;
      if (this.counter) this.counter.textContent = `${range} / ${this.cards.length}`;
      if (announce && this.status) this.status.textContent = `${this.dataset.listLabel}: ${range} / ${this.cards.length}`;
    }
  }
  customElements.define('imp-collection-carousel', ImpCollectionCarousel);
}

/*
 * Impressiko Collection Grid Pro: direct Add to Cart + optional Buy Now.
 * IMPORTANT: this store uses the separately installed Side Cart Drawer, not Dawn's
 * cart-drawer section. The dynamic section ID is read from its data-section-id.
 * Never redirect an Add to Cart click to /cart.
 */
if (!customElements.get('imp-collection-actions')) {
  class ImpCollectionActions extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      this.dialog = this.querySelector('[data-fc-dialog]');
      this.variantSelect = this.querySelector('[data-fc-variant-select]');
      this.errorNode = this.querySelector('[data-fc-error]');
      this.addButton = this.querySelector('[data-fc-action="add"]');
      this.buyButton = this.querySelector('[data-fc-action="buy"]');
      this.confirmButton = this.querySelector('[data-fc-dialog-confirm]');

      this.addEventListener('click', event => {
        const close = event.target.closest('[data-fc-dialog-close]');
        if (close) { this.dialog?.close(); return; }
        const confirm = event.target.closest('[data-fc-dialog-confirm]');
        if (confirm) {
          this.run(this.pendingAction || 'add', this.variantSelect?.value, confirm);
          return;
        }
        const actionButton = event.target.closest('[data-fc-action]');
        if (!actionButton || this.busy) return;
        const action = actionButton.dataset.fcAction;
        if (this.dataset.requiresPlan === 'true') {
          // Selling-plan products require an explicit plan choice on the PDP.
          window.location.assign(this.dataset.productUrl);
          return;
        }
        if (this.dataset.hasOptions === 'true') {
          this.pendingAction = action;
          this.error('');
          if (this.confirmButton) {
            this.confirmButton.classList.toggle('impressiko-product-card__button--buy', action === 'buy');
            const label = this.confirmButton.querySelector('[data-fc-label]');
            if (label) label.textContent = action === 'buy' ? this.dataset.buyText : this.dataset.addText;
          }
          if (typeof this.dialog?.showModal === 'function') {
            this.dialog.showModal();
            this.variantSelect?.focus();
          } else {
            window.location.assign(this.dataset.productUrl);
          }
          return;
        }
        this.run(action, this.dataset.variantId, actionButton);
      }, { signal: this.abortController.signal });

      this.dialog?.addEventListener('close', () => {
        this.pendingAction = null;
      }, { signal: this.abortController.signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }

    error(message) {
      if (!this.errorNode) return;
      this.errorNode.textContent = message;
      this.errorNode.hidden = !message;
    }

    setBusy(active, button) {
      this.busy = active;
      this.querySelectorAll('[data-fc-action], [data-fc-dialog-confirm]').forEach(node => {
        node.disabled = active;
      });
      if (!button) return;
      const label = button.querySelector('[data-fc-label]');
      if (active) {
        button.dataset.fcLoading = 'true';
        if (label) {
          button.dataset.fcOriginalLabel = label.textContent;
          label.textContent = this.dataset.addingText || 'Adding...';
        }
      } else {
        delete button.dataset.fcLoading;
        if (label && button.dataset.fcOriginalLabel !== undefined) {
          label.textContent = button.dataset.fcOriginalLabel;
          delete button.dataset.fcOriginalLabel;
        }
      }
    }

    findSideCart() {
      return document.querySelector('cart-drawer[data-side-cart-root][data-section-id]')
        || document.querySelector('cart-drawer[data-side-cart-root]');
    }

    parseSideCart(sectionHTML, expectedId) {
      if (typeof sectionHTML !== 'string' || !sectionHTML.trim()) return null;
      const parsed = new DOMParser().parseFromString(sectionHTML, 'text/html');
      const drawer = parsed.querySelector('cart-drawer[data-side-cart-root]');
      if (!drawer) return null;
      if (expectedId && drawer.dataset.sectionId && drawer.dataset.sectionId !== expectedId) return null;
      return drawer;
    }

    async fetchSideCartSection(sectionId) {
      // If bundled rendering returns null, try the Section Rendering API independently.
      // The ID must be the live dynamic group ID, never a hardcoded 'cart-drawer'.
      const root = window.Shopify?.routes?.root || '/';
      const paths = [window.location.pathname, root];
      for (const path of [...new Set(paths)]) {
        const url = new URL(path, window.location.origin);
        url.searchParams.set('section_id', sectionId);
        try {
          const response = await fetch(url.toString(), {
            method: 'GET',
            credentials: 'same-origin',
            headers: { 'Accept': 'text/html' },
            cache: 'no-store'
          });
          if (!response.ok) continue;
          const html = await response.text();
          if (this.parseSideCart(html, sectionId)) return html;
        } catch (error) {
          // A second path may work if this page template cannot render that section.
          console.warn('[Collection Grid Pro] Side cart section request failed:', error);
        }
      }
      return null;
    }

    updateCartBubble(html) {
      if (typeof html !== 'string' || !html) return;
      const existing = document.querySelector('#cart-icon-bubble');
      if (!existing) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const incoming = parsed.querySelector('#cart-icon-bubble');
      if (!incoming) return;

      // Keep the header cart link and its existing click listeners intact.
      // Replace only the count badge inside it.
      const currentBadge = existing.querySelector('.cart-count-bubble');
      const newBadge = incoming.querySelector('.cart-count-bubble');
      if (currentBadge && newBadge) {
        currentBadge.replaceWith(newBadge);
      } else if (currentBadge) {
        currentBadge.remove();
      } else if (newBadge) {
        existing.appendChild(newBadge);
      }
    }

    async updateSideCart(data, sectionId) {
      const current = this.findSideCart();
      if (!current || !sectionId) return null;
      if (current.renderSections?.(data?.sections, data?.item_count)) return current;

      let html = data?.sections?.[sectionId];
      let replacement = this.parseSideCart(html, sectionId);
      if (!replacement) {
        html = await this.fetchSideCartSection(sectionId);
        replacement = this.parseSideCart(html, sectionId);
      }
      if (!replacement) return null;
      if (current.renderSections?.({ [sectionId]: html }, data?.item_count)) return current;

      // Recreate the *custom* cart-drawer Web Component using the freshly rendered
      // Liquid, including its products, totals, rewards, offers, and recommendations.
      // This triggers connectedCallback in side-cart-drawer.js and avoids calling
      // Dawn's incompatible renderContents() or relying on 'cart-drawer' as an ID.
      current.replaceWith(document.importNode(replacement, true));
      return this.findSideCart();
    }

    static closeFallbackDrawer(drawer) {
      if (!drawer?.hasAttribute('data-fc-fallback-open')) return;
      drawer.removeAttribute('data-fc-fallback-open');
      drawer.classList.remove('active', 'is-open', 'open');
      drawer.setAttribute('aria-hidden', 'true');
      if (drawer.__fcPreviousOverflow !== undefined) {
        document.documentElement.style.overflow = drawer.__fcPreviousOverflow;
        delete drawer.__fcPreviousOverflow;
      }
      const origin = drawer.__fcOpener;
      if (origin?.isConnected) origin.focus({ preventScroll: true });
      delete drawer.__fcOpener;
    }

    static installFallbackClose() {
      if (ImpCollectionActions.fallbackInstalled) return;
      ImpCollectionActions.fallbackInstalled = true;
      document.addEventListener('click', event => {
        const close = event.target.closest?.('[data-side-cart-close]');
        if (!close) return;
        const drawer = close.closest('cart-drawer[data-side-cart-root][data-fc-fallback-open]');
        if (drawer) ImpCollectionActions.closeFallbackDrawer(drawer);
      }, true);
      document.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const drawer = document.querySelector('cart-drawer[data-side-cart-root][data-fc-fallback-open]');
        if (drawer) ImpCollectionActions.closeFallbackDrawer(drawer);
      }, true);
    }

    openSideCart(drawer, opener) {
      if (!drawer) return false;
      // Use the drawer's own controller whenever available. This preserves
      // its animations, overlay, focus trap and open/close logic.
      const nativeMethod = ['open', 'openDrawer', 'showDrawer'].find(name => typeof drawer[name] === 'function');
      if (nativeMethod) {
        try {
          drawer[nativeMethod](opener);
          return true;
        } catch (error) {
          console.warn('[Collection Grid Pro] Native side cart open failed; using fallback.', error);
        }
      }

      // The provided Liquid includes the root/panel/overlay but not the JS asset.
      // This independent fallback still opens it if there is no public JS opener.
      ImpCollectionActions.installFallbackClose();
      drawer.__fcOpener = opener;
      drawer.__fcPreviousOverflow = document.documentElement.style.overflow;
      drawer.setAttribute('data-fc-fallback-open', '');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.removeAttribute('inert');
      drawer.classList.add('active', 'is-open');
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        if (drawer.isConnected && drawer.hasAttribute('data-fc-fallback-open')) {
          drawer.querySelector('.side-cart__panel')?.focus({ preventScroll: true });
        }
      });
      return true;
    }

    /**
     * Reuse the existing side cart's burst if its controller exposes a public
     * no-argument method; otherwise display an equivalent configured particle
     * burst. We cannot rely on the drawer's internal add-to-cart event here,
     * because the featured section uses its own Shopify AJAX request.
     */
    triggerAddedBurst(drawer) {
      if (!drawer || drawer.dataset.burstEnabled !== 'true') return;
      if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;

      // Give the side panel a moment to enter after its own open() transition.
      window.setTimeout(() => {
        if (!drawer.isConnected || drawer.dataset.burstEnabled !== 'true') return;
        try {
          const methodNames = [
            'triggerPopBurst', 'playPopBurst', 'triggerBurst', 'playBurst',
            'showBurst', 'launchBurst', 'fireBurst', 'startBurst'
          ];
          const nativeMethod = methodNames.find(name => {
            const fn = drawer[name];
            return typeof fn === 'function' && fn.length === 0;
          });
          if (nativeMethod) {
            drawer[nativeMethod]();
            return;
          }
          this.showConfiguredBurst(drawer);
        } catch (error) {
          console.warn('[Collection Grid Pro] Native drawer burst failed; using configured burst.', error);
          try { this.showConfiguredBurst(drawer); } catch (_) { /* Non-critical visual effect */ }
        }
      }, 160);
    }

    showConfiguredBurst(drawer) {
      if (!drawer || drawer.dataset.burstEnabled !== 'true') return;
      const panel = drawer.querySelector('.side-cart__panel') || drawer.querySelector('#CartDrawer');
      if (!panel) return;

      const count = Math.min(80, Math.max(0, Math.round(Number(drawer.dataset.burstCount) || 48)));
      if (count === 0) return;
      const colors = (drawer.dataset.burstColors || '')
        .split(',')
        .map(c => c.trim())
        .filter(c => /^#[a-fA-F0-9]{3}(?:[a-fA-F0-9]{3})?(?:[a-fA-F0-9]{2})?$/.test(c));
      if (!colors.length) colors.push('#3e579e', '#12ad93', '#f6c555', '#e77871');

      // Clean any unfinished prior animation before starting another.
      document.querySelectorAll('.impressiko-sidecart-burst-layer').forEach(node => node.remove());

      const rect = panel.getBoundingClientRect();
      // Origin near the top of the visible cart panel (not the product card).
      const x = Math.round(Math.max(24, Math.min(innerWidth - 24, rect.left + rect.width * .50)));
      const y = Math.round(Math.max(42, Math.min(innerHeight - 42, rect.top + Math.min(155, rect.height * .25))));
      const layer = document.createElement('div');
      layer.className = 'impressiko-sidecart-burst-layer';
      layer.setAttribute('aria-hidden', 'true');
      layer.dataset.from = 'collection-grid-pro';
      const fragment = document.createDocumentFragment();

      for (let i = 0; i < count; i++) {
        const particle = document.createElement('i');
        particle.className = 'impressiko-sidecart-burst-particle';
        particle.setAttribute('aria-hidden', 'true');
        const angle = ((Math.PI * 2) * i / count) + (Math.random() - .5) * .55;
        const distance = 95 + Math.random() * Math.min(125, rect.width * .45);
        const dx = Math.round(Math.cos(angle) * distance);
        const dy = Math.round(Math.sin(angle) * distance + 55 + Math.random() * 55);
        const size = 5 + Math.random() * 6;
        const css = particle.style;
        css.setProperty('--fc-burst-x', `${x}px`);
        css.setProperty('--fc-burst-y', `${y}px`);
        css.setProperty('--fc-burst-dx', `${dx}px`);
        css.setProperty('--fc-burst-dy', `${dy}px`);
        css.setProperty('--fc-burst-w', `${size.toFixed(1)}px`);
        css.setProperty('--fc-burst-h', `${(size * (i % 4 ? 1.6 : 1)).toFixed(1)}px`);
        css.setProperty('--fc-burst-round', i % 5 === 0 ? '50%' : '1px');
        css.setProperty('--fc-burst-color', colors[i % colors.length]);
        css.setProperty('--fc-burst-time', `${780 + Math.round(Math.random() * 480)}ms`);
        css.setProperty('--fc-burst-delay', `${Math.round(Math.random() * 95)}ms`);
        css.setProperty('--fc-burst-rotation', `${-540 + Math.round(Math.random() * 1080)}deg`);
        fragment.appendChild(particle);
      }
      layer.appendChild(fragment);
      document.body.appendChild(layer);
      window.setTimeout(() => layer.remove(), 1500);
    }

    async run(action, variantId, trigger) {
      if (this.busy) return;
      const id = Number(variantId);
      if (!Number.isSafeInteger(id) || id <= 0) {
        this.error('Please select a valid product option.');
        return;
      }
      if (action === 'buy') {
        // Separate checkout flow: bypass the cart page and the drawer.
        const cartUrl = (this.dataset.cartUrl || '/cart').replace(/\/$/, '');
        window.location.assign(`${cartUrl}/${id}:1`);
        return;
      }

      this.dialog?.open && this.dialog.close();
      this.error('');
      const drawer = this.findSideCart();
      if (!drawer) {
        this.error('Side Cart Drawer is not loaded. Please enable it in your theme settings.');
        return;
      }

      if (drawer.beginAdd?.(this.addButton || trigger) === false) return;
      this.setBusy(true, trigger);
      const sectionId = drawer.dataset.sectionId || drawer.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '');
      const sections = [sectionId].filter(Boolean);
      const cartUrl = this.dataset.cartUrl || '/cart';
      let added = false;
      try {
        const addUrl = `${(this.dataset.addUrl || `${cartUrl}/add`).replace(/\/$/, '')}.js`;
        const response = await fetch(addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{ id, quantity: 1 }],
            sections,
            sections_url: window.location.pathname
          })
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Unable to add this item. Please try again.');
        }
        added = true;


        const refreshedDrawer = await this.updateSideCart(data, sectionId);
        const drawerToOpen = refreshedDrawer || this.findSideCart();
        if (refreshedDrawer) refreshedDrawer.showStatus?.(refreshedDrawer.dataset.addedMessage || 'Added to your cart', 'success');
        if (this.openSideCart(drawerToOpen, this.addButton || trigger)) {
          this.triggerAddedBurst(drawerToOpen);
        }
        if (!refreshedDrawer) {
          this.error('Added to cart, but the drawer could not refresh. Please try reopening the drawer.');
        }
      } catch (error) {
        this.error(added
          ? 'Added to cart, but its drawer could not be refreshed. Please try reopening it.'
          : (error?.message || 'Could not add this item. Please try again.'));
        if (added) {
          const remainingDrawer = this.findSideCart();
          if (this.openSideCart(remainingDrawer, this.addButton || trigger)) {
            this.triggerAddedBurst(remainingDrawer);
          }
        }
        this.findSideCart()?.showStatus?.(error?.message || 'Could not add this item.', 'error');
        console.error('[Collection Grid Pro] Add to cart:', error);
      } finally {
        drawer.endAdd?.();
        this.setBusy(false, trigger);
      }
    }
  }

  customElements.define('imp-collection-actions', ImpCollectionActions);
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
/* Measurements only on layout changes. Native CSS sticky owns scrolling. */
if (!customElements.get('imp-sticky-gallery-v2')) {
customElements.define('imp-sticky-gallery-v2', class extends HTMLElement {
connectedCallback() {
if (this._connected) return;
this._connected = true;
this._values = new Map();
this._width = 0;
this._headerHeight = 0;
this._mobileViewport = 0;
this._abort = new AbortController();
const options = { signal: this._abort.signal };
this._schedule = () => {
if (this._frame || !this.isConnected) return;
this._frame = requestAnimationFrame(() => {
this._frame = 0;
if (this._connected) this._measure();
});
};
window.addEventListener('resize', this._schedule, { ...options, passive: true });
this.addEventListener('load', this._schedule, { ...options, capture: true });
if ('ResizeObserver' in window) {
this._resize = new ResizeObserver(this._schedule);
this._resize.observe(this);
}
this._mutations = new MutationObserver(this._schedule);
this._mutations.observe(this, { childList: true, subtree: true });
if (document.fonts && document.fonts.ready) {
document.fonts.ready.then(() => { if (this._connected) this._schedule(); });
}
this._installMobileNavigation();
this._schedule();
}
disconnectedCallback() {
this._connected = false;
this._abort?.abort();
this._resize?.disconnect();
this._mutations?.disconnect();
cancelAnimationFrame(this._frame);
this._frame = 0;
this._watchedHeader = null;
if (this._mediaGallery?.setActiveMedia === this._mobileSetActive) {
  this._mediaGallery.setActiveMedia = this._originalSetActive;
}
this._mediaGallery = null;
cancelAnimationFrame(this._mobileScrollFrame);
}
_number(value, fallback = 0) {
const parsed = Number(value);
return Number.isFinite(parsed) ? parsed : fallback;
}
_set(name, value) {
value = Math.round(value * 10) / 10;
if (this._values.get(name) === value) return;
this._values.set(name, value);
this.style.setProperty(name, value + 'px');
}
_flag(name, value) {
const next = value ? 'true' : 'false';
if (this.dataset[name] !== next) this.dataset[name] = next;
}

_installMobileNavigation() {
  customElements.whenDefined('media-gallery').then(() => {
    if (!this._connected || !this.isConnected) return;
    const gallery = this.querySelector('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
    this._mediaGallery = gallery;
    this._originalSetActive = gallery.setActiveMedia;
    const original = this._originalSetActive;
    this._mobileSetActive = (mediaId, prepend) => {
      if (!window.matchMedia('(max-width: 749px)').matches) {
        return original.call(gallery, mediaId, prepend);
      }
      const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      const slides = Array.from(viewer?.querySelectorAll('.product__media-item[data-media-id]') || []);
      const target = slides.find(item => item.dataset.mediaId === String(mediaId)) || slides[0];
      if (!target) return;
      slides.forEach(item => item.classList.toggle('is-active', item === target));
      if (prepend && target.parentElement.firstElementChild !== target) {
        target.parentElement.prepend(target);
        const thumbnails = gallery.querySelector('[id^="GalleryThumbnails-"]');
        const selected = Array.from(thumbnails?.querySelectorAll('[data-target]') || []).find(item => item.dataset.target === String(mediaId));
        if (selected) selected.parentElement.prepend(selected);
        viewer.resetPages?.();
      }
      const list = target.parentElement;
      const left = target.getBoundingClientRect().left - list.getBoundingClientRect().left + list.scrollLeft;
      list.scrollTo({ left, behavior: 'instant' });
      gallery.playActiveMedia?.(target);
      const nativeThumb = Array.from(gallery.querySelectorAll('[data-target]')).find(item => item.dataset.target === target.dataset.mediaId);
      if (nativeThumb) {
        gallery.setActiveThumbnail?.(nativeThumb);
        if (nativeThumb.dataset.mediaPosition) gallery.announceLiveRegion?.(target, nativeThumb.dataset.mediaPosition);
      }
      this._syncMobileSelection(target);
    };
    gallery.setActiveMedia = this._mobileSetActive;
    // Scroll events do not bubble; capture the actual horizontal media list.
    this.addEventListener('scroll', event => {
      if (!window.matchMedia('(max-width: 749px)').matches ||
          !event.target.matches?.('.product__media-list') || this._mobileScrollFrame) return;
      this._mobileScrollFrame = requestAnimationFrame(() => {
        this._mobileScrollFrame = 0;
        if (!this._connected) return;
        const list = this.querySelector('[id^="GalleryViewer-"] .product__media-list');
        if (!list) return;
        const center = list.getBoundingClientRect().left + list.clientWidth / 2;
        const slides = Array.from(list.querySelectorAll('.product__media-item[data-media-id]')).filter(item => item.getClientRects().length);
        let nearest = null, distance = Infinity;
        slides.forEach(item => {
          const rect = item.getBoundingClientRect();
          const next = Math.abs(rect.left + rect.width / 2 - center);
          if (next < distance) { distance = next; nearest = item; }
        });
        if (!nearest) return;
        slides.forEach(item => item.classList.toggle('is-active', item === nearest));
        this._syncMobileSelection(nearest);
      });
    }, { capture: true, passive: true, signal: this._abort.signal });
  });
}
_syncMobileSelection(slide) {
  const track = this.querySelector('[data-custom-thumb-track]');
  let selected = null;
  this.querySelectorAll('[data-custom-thumb]').forEach(button => {
    const active = button.dataset.mediaId === slide.dataset.mediaId;
    const value = active ? 'true' : 'false';
    if (button.getAttribute('aria-current') !== value) button.setAttribute('aria-current', value);
    if (active) selected = button;
  });
  if (selected && track) {
    const left = selected.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    track.scrollTo({ left: Math.max(0, left - (track.clientWidth - selected.offsetWidth) / 2), behavior: 'instant' });
  }
  this.dispatchEvent(new CustomEvent('imp:mobile-media-change', { bubbles: true, detail: { mediaId: slide.dataset.mediaId } }));
}

_measure() {
const mobile = window.matchMedia('(max-width: 749px)').matches;
const active = !mobile && this._number(this.dataset.mediaCount) > 0 &&
this.dataset.stickyDesktop === 'true' &&
!this.closest('quick-add-modal, dialog, [role="dialog"]');
this._flag('igActive', active);
if (!active) { this._flag('igFit', false); return; }

const width = document.documentElement.clientWidth;
if (Math.abs(width - this._width) > 1) {
this._width = width;
this._headerHeight = 0;
this._mobileViewport = window.innerHeight;
}
const viewport = mobile ? this._mobileViewport : window.innerHeight;
const manual = this._number(mobile ? this.dataset.topMobile : this.dataset.topDesktop, 80);
let headerSpace = manual;
if (this.dataset.headerMode === 'auto') {
const header = document.querySelector('sticky-header') || document.querySelector('.section-header');
if (header !== this._watchedHeader) {
if (this._watchedHeader) this._resize?.unobserve(this._watchedHeader);
this._watchedHeader = header;
if (header) this._resize?.observe(header);
}
if (header) {
const host = header.closest('.shopify-section') || header;
const mode = header.dataset.stickyType;
const hostStyle = getComputedStyle(host);
const ownStyle = getComputedStyle(header);
const persistent = mode ? mode !== 'none' :
[hostStyle.position, ownStyle.position].some(p => p === 'sticky' || p === 'fixed');
if (persistent) {
const height = Math.max(host.offsetHeight, header.offsetHeight);
const top = Math.max(0, parseFloat(hostStyle.top) || 0, parseFloat(ownStyle.top) || 0);
// Do not follow scroll-up hiding or a shrinking-logo animation.
this._headerHeight = Math.max(this._headerHeight, height + top);
headerSpace = this._headerHeight;
} else headerSpace = 0;
} else headerSpace = 0;
}
const top = Math.max(0, headerSpace + this._number(this.dataset.headerGap, 12));
const remaining = Math.max(60, viewport - top - this._number(this.dataset.bottomGap, 24));
const share = Math.max(20, Math.min(50, this._number(this.dataset.mobileShare, 38)));
const budget = mobile ? Math.min(remaining, viewport * share / 100) : remaining;
this._set('--ig-top', top);
this._set('--ig-budget', budget);

const layout = mobile ? this.dataset.mobileMode : this.dataset.desktopMode;
const fit = this.dataset.stickyFit === 'true' && ['single', 'peek'].includes(layout);
this._flag('igFit', fit);
if (!fit) return;
const thumbs = this.querySelector('[data-custom-product-thumbnails]');
let thumbnailHeight = 0;
if (thumbs && getComputedStyle(thumbs).display !== 'none') {
const style = getComputedStyle(thumbs);
thumbnailHeight = thumbs.getBoundingClientRect().height +
(parseFloat(style.marginTop) || 0) + (parseFloat(style.marginBottom) || 0);
}
const style = getComputedStyle(this);
const padding = (parseFloat(style.paddingTop) || 0) + (parseFloat(style.paddingBottom) || 0);
const slide = this.querySelector('.product__media-item');
const stage = this.querySelector('.custom-product-gallery__stage');
const mediaWidth = (slide || stage || this).getBoundingClientRect().width;
const ratio = Math.max(0.05, this._number(this.dataset.previewRatio, 1));
const cap = Math.max(40, budget - thumbnailHeight - padding - 2);
this._set('--ig-main-height', Math.min(mediaWidth / ratio, cap));
}
});
}

/* Mobile preview has its own normal-flow slot inside the information column.
   Native sticky provides section-end release. No fixed overlays or y-scrollers. */
if (!customElements.get('imp-mobile-product-preview')) {
  customElements.define('imp-mobile-product-preview', class extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._root = this.closest('product-info');
      this._gallery = this._root?.querySelector('[data-custom-product-gallery]');
      if (!this._root || !this._gallery) return;
      this._abort = new AbortController();
      this._stableWidth = 0;
      this._lastTop = -1;
      const options = { signal: this._abort.signal };
      this._schedule = () => {
        if (this._frame || !this.isConnected) return;
        this._frame = requestAnimationFrame(() => {
          this._frame = 0;
          if (!this._connected || !matchMedia('(max-width: 749px)').matches) return;
          this._measureHeader();
        });
      };
      window.addEventListener('scroll', this._schedule, { ...options, passive: true });
      window.addEventListener('resize', this._schedule, { ...options, passive: true });
      this._root.addEventListener('imp:mobile-media-change', () => this._syncImage(), options);
      this.querySelector('a')?.addEventListener('click', event => {
        event.preventDefault();
        const stage = this._gallery.querySelector('.custom-product-gallery__stage');
        if (!stage) return;
        this._measureHeader();
        // Reserve the full header before scrolling back up, since it may reveal.
        const header = document.querySelector('sticky-header') || document.querySelector('.section-header');
        const host = header?.closest('.shopify-section') || header;
        const space = Math.max(this._lastTop, this._persistentHeader ? (host?.offsetHeight || 0) + (Number(this.dataset.headerGap) || 0) : 0);
        window.scrollTo({ top: Math.max(0, stage.getBoundingClientRect().top + window.scrollY - space), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, options);
      this._observer = new MutationObserver(() => this._syncImage());
      this._observer.observe(this._gallery, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-current', 'class', 'src', 'srcset'] });
      if ('ResizeObserver' in window) {
        this._headerObserver = new ResizeObserver(this._schedule);
        const header = document.querySelector('sticky-header') || document.querySelector('.section-header');
        if (header) this._headerObserver.observe(header);
      }
      this._syncImage();
      this._schedule();
    }
    disconnectedCallback() {
      this._connected = false;
      this._abort?.abort();
      this._observer?.disconnect();
      this._headerObserver?.disconnect();
      cancelAnimationFrame(this._frame);
      this._frame = 0;
    }
    _syncImage() {
      const image = this.querySelector('.imp-mobile-preview__image');
      if (!image || !this._gallery) return;
      const thumb = this._gallery.querySelector('[data-custom-thumb][aria-current="true"] img');
      const active = this._gallery.querySelector('.product__media-item.is-active .product__media img');
      const source = thumb || active;
      if (!source) return;
      const src = source.currentSrc || source.src;
      if (!src || image.getAttribute('src') === src) return;
      // Fixed dimensions prevent layout shifts when the selected image changes.
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = src;
    }
    _measureHeader() {
      let top = 0;
      const gap = Math.max(0, Number(this.dataset.headerGap) || 0);
      const header = document.querySelector('sticky-header') || document.querySelector('.section-header');
      this._persistentHeader = false;
      if (this.dataset.headerMode === 'manual') {
        top = Math.max(0, Number(this.dataset.topMobile) || 0);
      } else if (header) {
        const host = header.closest('.shopify-section') || header;
        const hs = getComputedStyle(host), own = getComputedStyle(header);
        const mode = header.dataset.stickyType;
        this._persistentHeader = mode ? mode !== 'none' : [hs.position, own.position].some(value => value === 'sticky' || value === 'fixed');
        if (this._persistentHeader) {
          const rect = host.getBoundingClientRect();
          const visible = hs.visibility !== 'hidden' && hs.display !== 'none';
          if (visible && rect.top < window.innerHeight && rect.bottom > 0) {
            // Only reserve the visible header; hiding a scroll-up header leaves
            // no tall blank space. The gallery's size is never changed here.
            top = Math.min(rect.bottom, host.offsetHeight + Math.max(0, parseFloat(hs.top) || 0));
          }
        }
      }
      const nextTop = Math.round(Math.max(0, top) + gap);
      if (nextTop !== this._lastTop) {
        this._lastTop = nextTop;
        this.style.setProperty('--mp-top', nextTop + 'px');
      }
      const width = document.documentElement.clientWidth;
      if (Math.abs(width - this._stableWidth) > 1) {
        this._stableWidth = width;
        const share = Math.max(20, Math.min(50, Number(this.dataset.heightShare) || 38));
        const limit = Math.max(32, Math.min(120, window.innerHeight * share / 100 - 18));
        this.style.setProperty('--mp-image-limit', limit + 'px');
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noki-brew-matcha"] && !Shopify.designMode) return;
  try {
    
  /* Register once, even if multiple Brew Matcha sections are on the page.
     Sources are attached only when needed; Shopify-hosted MP4s only. */
  if (!customElements.get('impressiko-brew-matcha')) {
    class ImpressikoBrewMatcha extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;
        this._connected = true;
        this._videos = Array.from(this.querySelectorAll('[data-brew-video]'));
        this._visible = new Set();
        this._reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._autoplay = this.dataset.autoplay === 'true';
        this._pauseOffscreen = this.dataset.pauseOffscreen === 'true';

        this._onClick = (event) => {
          const button = event.target.closest('[data-brew-toggle]');
          if (button && this.contains(button)) {
            const video = button.closest('[data-brew-media]')?.querySelector('[data-brew-video]');
            if (video) this.toggle(video);
            return;
          }
          // On touch devices, tapping the video itself also plays/pauses it.
          const media = event.target.closest('[data-brew-media]');
          if (media && this.contains(media)) {
            const video = media.querySelector('[data-brew-video]');
            if (video) this.toggle(video);
          }
        };
        this.addEventListener('click', this._onClick);

        this._onVisibilityChange = () => {
          if (document.hidden) {
            this._videos.forEach(video => video.pause());
          } else if (this.canAutoplay()) {
            this._visible.forEach(video => this.play(video));
          }
        };
        document.addEventListener('visibilitychange', this._onVisibilityChange);

        // Browser autoplay policy requires the video to be muted.
        this._videos.forEach(video => {
          video.muted = true;
          video.addEventListener('play', () => this.updateToggle(video, true));
          video.addEventListener('pause', () => this.updateToggle(video, false));
          video.addEventListener('ended', () => this.updateToggle(video, false));
        });

        if ('IntersectionObserver' in window) {
          this._observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              const video = entry.target;
              if (entry.isIntersecting) {
                this._visible.add(video);
                if (this.canAutoplay()) this.play(video);
              } else {
                this._visible.delete(video);
                if (this._pauseOffscreen && !video.paused) video.pause();
              }
            });
          }, { rootMargin: '120px 0px 120px 0px', threshold: 0.1 });
          this._videos.forEach(video => this._observer.observe(video));
        } else if (this.canAutoplay()) {
          this._videos.forEach(video => this.play(video));
        }
      }

      disconnectedCallback() {
        this._observer?.disconnect();
        this.removeEventListener('click', this._onClick);
        document.removeEventListener('visibilitychange', this._onVisibilityChange);
        this._videos?.forEach(video => video.pause());
        this._visible?.clear();
        this._connected = false;
      }

      canAutoplay() {
        return this._autoplay && !this._reduceMotion.matches && !document.hidden;
      }

      attachSource(video) {
        if (video.dataset.brewLoaded === 'true') return;
        const source = video.querySelector('source[data-src]');
        if (!source) return;
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
        video.dataset.brewLoaded = 'true';
        video.load();
      }

      play(video) {
        if (video.dataset.brewUserPaused === 'true') return;
        this.attachSource(video);
        video.muted = true;
        const attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch(() => this.updateToggle(video, false));
        }
      }

      toggle(video) {
        if (video.paused || video.ended) {
          video.dataset.brewUserPaused = 'false';
          this.play(video);
        } else {
          video.dataset.brewUserPaused = 'true';
          video.pause();
        }
      }

      updateToggle(video, playing) {
        const button = video.closest('[data-brew-media]')?.querySelector('[data-brew-toggle]');
        if (!button) return;
        button.setAttribute('aria-pressed', playing ? 'true' : 'false');
        const title = video.getAttribute('aria-label') || 'video';
        button.setAttribute('aria-label', `${playing ? 'Pause' : 'Play'} ${title}`);
      }
    }
    customElements.define('impressiko-brew-matcha', ImpressikoBrewMatcha);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noki-recipes-dawn"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('noki-recipes')) {
    customElements.define('noki-recipes', class extends HTMLElement {
      connectedCallback() {
        this.previousWidth = 0;
        this.fitTitles = () => {
          this.querySelectorAll('[data-noki-fit]').forEach(title => {
            const width = title.offsetWidth;
            if (!width || !title.textContent.trim()) return;
            let low = 1;
            let high = 500;
            for (let i = 0; i < 30 && high - low > .5; i++) {
              const size = (low + high) / 2;
              title.style.fontSize = size + 'px';
              if (title.scrollWidth > width) high = size;
              else low = size;
            }
            title.style.fontSize = low * .99 + 'px';
          });
        };
        this.observer = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width;
          if (Math.abs(width - this.previousWidth) > 1) {
            this.previousWidth = width;
            requestAnimationFrame(this.fitTitles);
          }
        });
        this.observer.observe(this);
        this.fitTitles();
        document.fonts.ready.then(() => { if (this.isConnected) this.fitTitles(); });
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
/* Native-scroll carousel. No product clones or changes to Dawn's quick-add flow. */
if (!customElements.get('imp-featured-carousel')) {
  class ImpFeaturedCarousel extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.measureFrame);
      cancelAnimationFrame(this.scrollFrame);
      clearTimeout(this.settleTimer);
      this.events?.abort();
      this.observer?.disconnect();
      this.endDrag(false);
      this.ready = false;
    }

    init() {
      if (this.ready || !this.isConnected) return;
      this.viewport = this.querySelector('[data-fc-track]');
      if (!this.viewport) return;
      this.cards = Array.from(this.viewport.children).filter(node => node.matches('.impressiko-product-card'));
      if (!this.cards.length) return;
      this.ready = true;
      this.events = new AbortController();
      this.controls = this.querySelector('[data-fc-controls]');
      this.prev = this.querySelector('[data-fc-prev]');
      this.next = this.querySelector('[data-fc-next]');
      this.dots = this.querySelector('[data-fc-dots]');
      this.counter = this.querySelector('[data-fc-counter]');
      this.progress = this.querySelector('[data-fc-progress]');
      this.status = this.querySelector('[data-fc-status]');
      this.media = matchMedia('(min-width: 750px)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.positions = [0];
      this.index = 0;
      const listen = (node, type, fn, options = {}) => {
        if (node) node.addEventListener(type, fn, { ...options, signal: this.events.signal });
      };

      listen(this.prev, 'click', () => this.step(-1));
      listen(this.next, 'click', () => this.step(1));
      listen(this.dots, 'click', event => {
        const button = event.target.closest('[data-fc-dot]');
        if (button) this.go(Number(button.dataset.fcDot));
      });
      listen(this.viewport, 'scroll', () => {
        if (!this.scrollFrame) this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = 0;
          this.update();
        });
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => {
          this.pending = null;
          this.update(true);
        }, 140);
      }, { passive: true });
      listen(this.viewport, 'keydown', event => {
        // Leave buttons, product links and quick-view keyboard controls alone.
        if (event.target !== this.viewport || !this.enabled || this.max < 2) return;
        const forward = this.rtl ? 'ArrowLeft' : 'ArrowRight';
        const backward = this.rtl ? 'ArrowRight' : 'ArrowLeft';
        if (event.key === forward) this.step(1);
        else if (event.key === backward) this.step(-1);
        else if (event.key === 'Home') this.go(0);
        else if (event.key === 'End') this.go(this.positions.length - 1);
        else return;
        event.preventDefault();
      });
      listen(this.viewport, 'focusin', event => {
        if (!this.enabled || this.drag) return;
        const card = event.target.closest('.impressiko-product-card');
        if (!card || card.parentElement !== this.viewport) return;
        const box = card.getBoundingClientRect();
        const frame = this.viewport.getBoundingClientRect();
        if (box.left < frame.left - 2 || box.right > frame.right + 2) {
          const index = this.cards.indexOf(card);
          const target = Math.min(this.max, Math.max(0, this.offsets[index]));
          this.scrollToOffset(target);
        }
      });

      // Touch/pen scrolling remains native, including vertical page movement.
      listen(this.viewport, 'pointerdown', event => {
        if (!this.enabled || this.max < 2 || this.dataset.mouseDrag !== 'true') return;
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (event.target.closest('button, input, select, textarea, summary, modal-opener, [role="button"]')) return;
        this.pending = null;
        this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, position: this.position(), moved: false };
      });
      listen(window, 'pointermove', event => {
        const drag = this.drag;
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.x;
        const dy = event.clientY - drag.y;
        if (!drag.moved) {
          if (Math.abs(dx) < 6) return;
          if (Math.abs(dy) > Math.abs(dx)) { this.drag = null; return; }
          drag.moved = true;
          this.viewport.classList.add('is-fc-dragging');
          try { this.viewport.setPointerCapture(drag.id); } catch (_) { /* Pointer may already be released. */ }
        }
        if (event.cancelable) event.preventDefault();
        this.setPosition(drag.position + (this.rtl ? dx : -dx));
      });
      listen(window, 'pointerup', event => {
        if (this.drag?.id === event.pointerId) this.endDrag(true);
      });
      listen(window, 'pointercancel', event => {
        if (this.drag?.id === event.pointerId) this.endDrag(false);
      });
      listen(this.viewport, 'dragstart', event => {
        if (this.enabled && this.dataset.mouseDrag === 'true') event.preventDefault();
      });
      listen(this.viewport, 'click', event => {
        if (performance.now() < (this.suppressClickUntil || 0)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { capture: true });

      this.lastWidth = -1;
      const scheduleMeasure = () => {
        if (!this.measureFrame) this.measureFrame = requestAnimationFrame(() => {
          this.measureFrame = 0;
          this.measure();
        });
      };
      listen(window, 'resize', scheduleMeasure, { passive: true });
      listen(this.media, 'change', scheduleMeasure);
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => {
          const width = this.viewport.clientWidth;
          if (Math.abs(width - this.lastWidth) > 0.5) scheduleMeasure();
        });
        this.observer.observe(this.viewport);
      }
      this.measure();
    }

    position() {
      const raw = this.rtl ? -this.viewport.scrollLeft : this.viewport.scrollLeft;
      return Math.min(this.max || 0, Math.max(0, raw));
    }

    setPosition(value) {
      const position = Math.max(0, Math.min(this.max, value));
      this.viewport.scrollLeft = this.rtl ? -position : position;
    }

    scrollToOffset(value, smooth = true) {
      const position = Math.max(0, Math.min(this.max, value));
      this.viewport.scrollTo({
        left: this.rtl ? -position : position,
        behavior: smooth && !this.motion.matches ? 'smooth' : 'auto'
      });
    }

    measure() {
      if (!this.isConnected || !this.ready) return;
      this.endDrag(false);
      const oldAnchor = this.anchor || 0;
      const oldEnabled = this.enabled;
      const desktop = this.media.matches;
      this.enabled = (desktop ? this.dataset.desktopSlider : this.dataset.mobileSlider) === 'true';
      this.rtl = getComputedStyle(this.viewport).direction === 'rtl';
      this.lastWidth = this.viewport.clientWidth;
      this.max = Math.max(0, this.viewport.scrollWidth - this.lastWidth);
      const frame = this.viewport.getBoundingClientRect();
      const current = this.position();
      this.offsets = this.cards.map(card => {
        const box = card.getBoundingClientRect();
        return current + (this.rtl ? frame.right - box.right : box.left - frame.left);
      });
      this.positions = [0];
      if (this.enabled && this.max > 2) {
        this.offsets.slice(1).forEach(offset => {
          const value = Math.max(0, Math.min(this.max, offset));
          if (value - this.positions[this.positions.length - 1] > 2) this.positions.push(value);
        });
        if (this.max - this.positions[this.positions.length - 1] > 2) this.positions.push(this.max);
      }
      const overflow = this.enabled && this.max > 2;
      this.dataset.fcOverflow = String(overflow);
      this.viewport.tabIndex = overflow ? 0 : -1;
      this.viewport.setAttribute('aria-label', overflow ? this.dataset.sliderLabel : this.dataset.listLabel);
      const showArrows = overflow && (desktop ? this.dataset.arrowsDesktop : this.dataset.arrowsMobile) === 'true';
      const pagination = desktop ? this.dataset.paginationDesktop : this.dataset.paginationMobile;
      if (this.prev) this.prev.hidden = !showArrows;
      if (this.next) this.next.hidden = !showArrows;
      if (this.counter) this.counter.hidden = !overflow || pagination !== 'counter';
      if (this.progress) this.progress.hidden = !overflow || pagination !== 'progress';
      if (this.dots) this.dots.hidden = !overflow || pagination !== 'dots';
      if (this.controls) this.controls.hidden = !overflow || (!showArrows && pagination === 'none');
      this.pagination = pagination;
      if (this.dots && this.dots.children.length !== this.positions.length) {
        const fragment = document.createDocumentFragment();
        this.positions.forEach((_, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'impressiko-featured__dot';
          button.dataset.fcDot = String(index);
          button.setAttribute('aria-controls', this.viewport.id);
          button.setAttribute('aria-label', `${this.dataset.positionLabel} ${index + 1}`);
          fragment.appendChild(button);
        });
        this.dots.replaceChildren(fragment);
      }
      this.pending = null;
      if (!this.enabled || !oldEnabled) this.setPosition(0);
      else this.setPosition(this.offsets[Math.min(oldAnchor, this.cards.length - 1)] || 0);
      this.update();
    }

    nearest(value) {
      let best = 0;
      let distance = Infinity;
      this.positions.forEach((position, index) => {
        if (Math.abs(position - value) < distance) {
          distance = Math.abs(position - value);
          best = index;
        }
      });
      return best;
    }

    go(index, smooth = true) {
      if (!this.enabled || this.max < 2) return;
      const clamped = Math.max(0, Math.min(this.positions.length - 1, index));
      this.pending = clamped;
      this.scrollToOffset(this.positions[clamped], smooth);
      if (!smooth || this.motion.matches) this.update(true);
    }

    step(direction) {
      const desktop = this.media.matches;
      const columns = Number(desktop ? this.dataset.columnsDesktop : this.dataset.columnsMobile) || 1;
      const jump = this.dataset.scrollStep === 'page' ? Math.max(1, Math.floor(columns)) : 1;
      this.go((this.pending ?? this.nearest(this.position())) + jump * direction);
    }

    endDrag(snap) {
      const drag = this.drag;
      if (!drag) return;
      this.drag = null;
      if (drag.moved) {
        const position = this.position();
        this.suppressClickUntil = performance.now() + 350;
        this.viewport.classList.remove('is-fc-dragging');
        try { this.viewport.releasePointerCapture(drag.id); } catch (_) { /* Already released. */ }
        if (snap && this.dataset.snap === 'true') this.go(this.nearest(position));
      }
    }

    update(announce = false) {
      if (!this.ready) return;
      const value = this.position();
      this.index = this.nearest(value);
      if (this.prev) this.prev.disabled = value <= 2;
      if (this.next) this.next.disabled = value >= this.max - 2;
      if (this.dots) Array.from(this.dots.children).forEach((button, index) => {
        if (index === this.index) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      if (this.progress) {
        const fraction = (this.index + 1) / this.positions.length;
        this.progress.style.setProperty('--fc-progress', String(fraction));
      }
      const visible = [];
      this.offsets.forEach((offset, index) => {
        const width = this.cards[index].getBoundingClientRect().width;
        if (offset + width > value + 2 && offset < value + this.lastWidth - 2) visible.push(index);
      });
      this.anchor = visible[0] || 0;
      const first = this.anchor + 1;
      const last = (visible[visible.length - 1] ?? this.anchor) + 1;
      const range = first === last ? String(first) : `${first}\u2013${last}`;
      if (this.counter) this.counter.textContent = `${range} / ${this.cards.length}`;
      if (announce && this.status) this.status.textContent = `${this.dataset.listLabel}: ${range} / ${this.cards.length}`;
    }
  }
  customElements.define('imp-featured-carousel', ImpFeaturedCarousel);
}

  } catch(e) { console.error(e); }
})();
})();
